// 引用css
import '../scss/base.scss';
import '../scss/mobile.scss';
// 开发引用html，热更新
if (process.env.NODE_ENV === 'development') {
	require('raw-loader!../indexm.html');
	require('raw-loader!../_main_m.html');
}

import $ from 'jquery';
import tips from './tips';
import * as service from './service';
service.init();

var active = {
	$root: $('.page'),

	state: {
		verfiedAPI: '//eventsapi.gm99.com/serial_exchange/check_code?time=',
		gameAPI: '//eventsapi.gm99.com/serial_exchange/game_lists?callback=?',
		serverAPI: '//eventsapi.gm99.com/serial_exchange/server_lists?callback=?',
		roleAPI: '//eventsapi.gm99.com/serial_exchange/get_game_role?callback=?',
		submitAPI: '//eventsapi.gm99.com/serial_exchange/get_award?callback=?',
		checkAPI: '//eventsapi.gm99.com/serial_exchange/select_award?callback=?',
		status: 0
	},

	val: {
		gameId: -1,
		gameGet: 0,
		gameFlag: 0,
		serverId: -1,
		serverGet: 0,
		serverFlag: 0,
		roleId: -1,
		roleGet: 0,
		roleName: null,
		roleFlag: 0,
		redeem: null,
		verfied: null,
		gameList: null,
		serverList: {},
		roleList: {},
		curPage: 1,
		historyGet: 0
	},

	el: {
		$item: $('.item'),
		$list: $('.list'),
		$array: $('.item-array'),
		$button: $('.table-button'),
		$gameArray: $('#J_game_array'),
		$gameText: $('#J_game_text'),
		$gameList: $('#J_game_list'),
		$serverArray: $('#J_server_array'),
		$serverText: $('#J_server_text'),
		$serverList: $('#J_server_list'),
		$roleArray: $('#J_role_array'),
		$roleText: $('#J_role_text'),
		$roleList: $('#J_role_list'),
		$redeemCode: $('#J_redeem_code'),
		$verfiedCode: $('#J_verfied_code'),
		$verfiedPic: $('#J_verfied_pic'),
		$shade: $('#J_shade'),
		$history: $('#J_history'),
		$table: $('#J_history_table')
	},

	init: function() {
		this.setup();
		this.bindEvent();
		tips.init();
	},

	setup: function() {
		var me = this;

		$.getJSON(me.state.gameAPI, function(gameResult) {
			if (gameResult.result) {
				me.state.status = 1;
				var dpr = window.devicePixelRatio;
				if (navigator.appVersion.match(/iphone/gi)) {
					if (dpr == 2) {
						$('.notation').css({
							'margin-top': '54px'
						});
					} else if (dpr == 3) {
						$('.notation').css({
							'margin-top': '81px'
						});
					}
				} else {
					$('.notation').css({
						'margin-top': '27px'
					});
				}
				$('.table-history').show();

				me.el.$verfiedPic.attr('src', me.state.verfiedAPI + Math.random());

				var url = window.parent.document.URL;
				me.setupData(url);
			}
		});

		me.renderGame();
	},

	bindEvent: function() {
		var me = this;
		//submit
		this.$root.on('click', '.table-button', function(event) {
			if (me.state.status) {
				if (me.checkVal()) {
					me.submitForm();
				}
			} else {
				me.login();
			}
		});

		// change the redeem code
		this.$root.on('change', '#J_redeem_code', function(event) {
			me.val.redeem = me.el.$redeemCode.val();
		});

		//change the verfied code
		this.$root.on('change', '#J_verfied_code', function(event) {
			me.val.verfied = me.el.$verfiedCode.val();
		});

		this.$root.on('click', '#J_redeem_code, #J_verfied_code', function(event) {
			if (!me.state.status) {
				me.login();
			}
		});

		// change the verfied pic
		this.$root.on('click', '#J_verfied_pic, #J_verfied_refresh', function(event) {
			if (me.state.status) {
				me.el.$verfiedPic.attr('src', me.state.verfiedAPI + Math.random());
			} else {
				me.login();
			}
		});

		this.$root.on('click', '.item-placeholder', function(event) {
			if (!me.state.status) {
				me.login();
			}
		});

		// click the list item
		this.$root.on('change', '#J_game_list', function(event) {
			me.selectGame(event);
		});

		// click the list item
		this.$root.on('change', '#J_server_list', function(event) {
			me.selectServer(event);
		});

		this.$root.on('change', '#J_role_list', function(event) {
			me.selectRole(event);
		});

		this.$root.on('click', '#J_show_history', function(event) {
			if (me.state.status) {
				me.showHistory();
			} else {
				me.login();
			}
		});

		this.$root.on('click', '#J_shade', function(event) {
			me.closeList(event);
		});
	},

	checkVal: function() {
		var me = this;

		if (!me.val.gameId) {
			alert(tips.get('gameNone'));
		} else if (!me.val.serverId) {
			alert(tips.get('serverNone'));
		} else if (!me.val.roleId) {
			alert(tips.get('roleNone'));
		} else if (!me.val.redeem) {
			alert(tips.get('redeemNone'));
		// } else if (me.checkValid(me.val.redeem)) {
		// 	alert(tips.get('unexist'));
		// 	me.el.$redeemCode.val('');
		// 	me.val.redeem = null;
		// 	me.el.$verfiedCode.val('');
		// 	me.val.verfied = null;
		} else if (!me.val.verfied) {
			alert(tips.get('verfiedNone'));
		} else if (me.checkValid(me.val.verfied)) {
			alert(tips.get('verfiedNone'));
			me.el.$verfiedCode.val('');
			me.val.verfied = null;
		} else {
			return 1;
		}
	},

	checkValid: function(str) {
		var pattern = new RegExp('^[A-Za-z0-9]+$');

		if (pattern.test(str)) {
			return 0;
		}
		return 1;
	},

	renderGame: function() {
		var me = this;
		if (!me.val.gameGet) {
			$.getJSON(me.state.gameAPI, function(gameResult) {
				if (gameResult.result) {
					me.setGame(me.el.$gameList, gameResult.data);
					me.val.gameGet = 1;
				}
			});
		}
	},

	setGame: function(target, data) {
		var me = this;
		var list = "<option class='game-item' value='-1'>請選擇遊戲</option>";
		me.val.gameList = data;
		for (var i = 0; i < data.length; i++) {
			list += "<option class='game-item' value='" + data[i].GAME_ID + "'>" + data[i].NAME + '</option>';
		}

		target.html(list);
	},

	renderServer: function() {
		var me = this;

		if (me.val.gameId != -1) {
			if (!me.val.serverGet) {
				$.getJSON(me.state.serverAPI, { game_id: me.val.gameId }, function(serverResult) {
					if (serverResult.result) {
						me.setServer(me.el.$serverList, serverResult.data);
						me.val.serverGet = 1;
					}
				});
			}
		}
	},

	setServer: function(target, data) {
		var me = this;
		// clear the server list
		me.val.serverList = {};

		var list = "<option value='-1'>請選擇伺服器</option>";
		for (var i = 0; i < data.length; i++) {
			me.val.serverList[data[i].ID] = data[i].NAME;
			list = list + "<option class='server-item' value='" + data[i].ID + "'>" + data[i].NAME + '</option>';
		}
		target.html(list);
	},

	renderRole: function() {
		var me = this;
		if (me.val.gameId != -1) {
			if (me.val.serverId != -1) {
				// if already get the role
				if (!me.val.roleGet) {
					$.getJSON(me.state.roleAPI, { game_id: me.val.gameId, server_id: me.val.serverId }, function(roleResult) {
						if (roleResult.result) {
							if (roleResult.data.length == 0) {
								me.el.$roleList.html("<option value='-1'>您還沒有創建角色喔</option>");
							} else {
								me.setRole(me.el.$roleList, roleResult.data);
								me.val.roleGet = 1;
							}
						}
					});
				}
			}
		}
	},

	setRole: function(target, data) {
		var me = this;
		var list = "<option value='-1'>請選擇角色</option>";
		for (var i = 0; i < data.length; i++) {
			me.val.roleList[data[i].roleID] = data[i].roleName;
			list = list + "<option value='" + data[i].roleID + "'>" + data[i].roleName + '</option>';
		}
		target.html(list);
	},

	resetServer: function(event) {
		var me = this;

		me.el.$serverText.text('請選擇伺服器');
		me.el.$serverList.html("<option value='-1'>請選擇伺服器</option>");
		me.el.$roleText.text('請選擇角色');
		me.el.$roleList.html("<option value='-1'>請選擇角色</option>");
		me.val.serverGet = null;
		me.val.serverId = null;
		me.val.roleGet = null;
		me.val.roleId = null;
		me.val.roleName = null;
	},

	selectGame: function(event) {
		var me = this;

		// if select a new game
		if (event.target.value == -1) {
			me.el.$gameText.text('請選擇遊戲');
			me.val.gameId = -1;
			me.resetServer();
		} else if (me.val.gameId != event.target.value) {
			me.val.gameId = event.target.value;
			for (var i = 0; i < me.val.gameList.length; i++)
				me.val.gameList[i].GAME_ID == me.val.gameId ? me.el.$gameText.text(me.val.gameList[i].NAME) : null;
			// me.el.$gameText.text(me.val.gameList[me.val.gameId]);
			me.resetServer();
			me.renderServer();
		}
	},

	resetRole: function(event) {
		var me = this;

		me.val.roleGet = null;
		me.val.roleId = null;
		me.val.roleName = null;
		me.el.$roleText.text('請選擇角色');
		me.el.$roleList.html("<option value='-1'>請選擇角色</option>");
	},

	selectServer: function(event) {
		var me = this;
		if (event.target.value == -1) {
			me.el.$serverText.text('請選擇伺服器');
			me.val.serverId = -1;
			me.resetRole();
		}
		// if select a new server
		else if (me.val.serverId != event.target.value) {
			me.val.serverId = event.target.value;
			me.el.$serverText.text(me.val.serverList[me.val.serverId]);
			// reset the role info
			me.resetRole();
			me.renderRole();
		}
	},

	selectRole: function(event) {
		var me = this;
		// if select a new role
		if (event.target.value == -1) {
			me.el.$serverText.text('請選擇角色');
		} else if (me.val.roleId != event.target.value) {
			me.val.roleId = event.target.value;
			me.el.$roleText.text(me.val.roleList[me.val.roleId]);
			me.val.roleName = me.el.$roleText.text();
			me.val.roleGet = null;
		}
	},

	submitForm: function() {
		var me = this;
		me.el.$button.attr('disabled', '');

		$.getJSON(
			me.state.submitAPI,
			{
				game_id: me.val.gameId,
				code: me.val.redeem,
				server_id: me.val.serverId,
				check_code: me.val.verfied,
				role_name: me.val.roleName,
				role_id: me.val.roleId
			},
			function(submitResult) {
				if (submitResult.result) {
					me.errorCode(submitResult.code);
					me.val.historyGet = 0;
					me.el.$verfiedPic.attr('src', me.state.verfiedAPI + Math.random());
					me.el.$redeemCode.val('');
					me.el.$verfiedCode.val('');
					me.val.verfied = null;
					me.val.redeem = null;
				} else {
					me.el.$verfiedPic.attr('src', me.state.verfiedAPI + Math.random());
					me.errorCode(submitResult.code);
					me.el.$verfiedCode.val('');
					me.val.verfied = null;
				}
				me.el.$button.removeAttr('disabled');
			}
		);
	},

	showHistory: function() {
		var me = this;
		if (!me.val.historyGet) {
			// get the game list
			$.getJSON(me.state.gameAPI, function(gameResult) {
				me.val.gameList = gameResult.data;
			});
			$.getJSON(me.state.checkAPI, function(checkResult) {
				me.setHistory(me.el.$table, checkResult.data);
				me.val.historyGet = 1;
			});
		}
		me.el.$shade.show();
		me.el.$history.show();
	},

	hideHistory: function() {
		var me = this;

		me.el.$shade.hide();
		me.el.$history.hide();
	},

	getUrlParams: function(url, key) {
		var r = '[?&]+' + key + '=([^&]+)*';
		var b = url.match(new RegExp(r, 'i'));
		return b ? b[1] : '';
	},

	setupData: function(url) {
		var me = this;
		var gnum = me.getUrlParams(url, 'gameId') || me.getUrlParams(url, 'game_id');
		if (gnum) {
			// get the game id
			me.val.gameId = gnum;
			$.getJSON(me.state.gameAPI, function(gameResult) {
				for (var i = 0; i < gameResult.data.length; i++)
					gameResult.data[i].GAME_ID == me.val.gameId ? me.el.$gameText.text(gameResult.data[i].NAME) : null;

				//get the server
				var snum = me.getUrlParams(url, 'serverId') || me.getUrlParams(url, 'server_id');

				$.getJSON(me.state.serverAPI, { game_id: me.val.gameId }, function(serverResult) {
					for (var i = 0; i < serverResult.data.length; i++) {
						if (snum == serverResult.data[i].SID) {
							me.el.$serverText.text(serverResult.data[i].NAME);
							me.val.serverId = serverResult.data[i].ID;
						}
					}
					me.renderServer();
					var rnum = me.getUrlParams(url, 'role_id') || me.getUrlParams(url, 'roleId');
					me.val.roleId = rnum;
					$.getJSON(me.state.roleAPI, { game_id: me.val.gameId, server_id: me.val.serverId }, function(roleResult) {
						for (var i = 0; i < roleResult.data.length; i++) {
							if (rnum == roleResult.data[i].roleID) {
								me.el.$roleText.text(roleResult.data[i].roleName);
								me.val.roleName = roleResult.data[i].roleName;
							}
						} // end for
						me.renderRole();
					});
				});
			});
		}
	},

	setHistory: function(target, list) {
		var me = this;

		// title
		target.html(
			'<tr class="history-table-title">' +
				'<td class="history-table-item">禮包</td>' +
				'<td class="history-table-item">兌換角色</td>' +
				'<td class="history-table-item">兌換時間</td>' +
				'</tr>'
		); //end append
		// content
		var i = 0;
		while (i < list.length) {
			var game = list[i].GAME_ID;
			target.append(
				'<tr class="history-table-record">' +
					'<td class="history-table-item">' +
					list[i].NAME +
					'</td>' +
					'<td class="history-table-item">' +
					list[i].ROLE_NAME +
					'</td>' +
					'<td class="history-table-item">' +
					list[i].TIME.substring(0, 10) +
					'</td>' +
					'</tr>'
			); //end append
			i++;
		} // end while
	},

	login: function() {
		alert(tips.get('login'));
		window.location.href = '//passport.gm99.com/?zone=zh&device=2&forward=' + encodeURIComponent(window.location.href);
	},

	closeList: function(event) {
		var me = this;
		me.el.$shade.hide();
		me.el.$list.hide();
		me.el.$history.hide();
	},

	errorCode: function(code) {
		var me = this;
		switch (code) {
			case -10000:
				alert(tips.get('varError'));
				break;
			case -20002:
				alert(tips.get('noRole'));
				break;
			case -10001:
				alert(tips.get('verfiedError'));
				break;
			case -10002:
				alert(tips.get('gameMaintain'));
				break;
			case -10004:
				alert(tips.get('serverMaintain'));
				break;
			case -10005:
				alert(tips.get('roleUnexist'));
				break;
			case -10006:
				alert(tips.get('gameWrong'));
				break;
			case -10007:
				alert(tips.get('toMany'));
				break;
			case -10008:
				alert(tips.get('sendFail'));
				break;
			case -10009:
				alert(tips.get('retry'));
				break;
			case -10010:
				alert(tips.get('failRetry'));
				break;
			case -10011:
				alert(tips.get('used'));
				break;
			case -10012:
				alert(tips.get('expired'));
				break;
			case -10013:
				alert(tips.get('unexist'));
				break;
			case 10000:
				alert(tips.get('success'));
				break;
			case -20007:
				alert(tips.get('useMax'));
				break;
			default:
				alert('錯誤');
		}
	}
};

active.init();
